<h3 mat-dialog-title class="title">{{ data.translations.title }}</h3>

<mat-dialog-content>
    <div class="content">
        <div class="title">{{ addFromLabelKey | translate }}:</div>
        <div class="type-select-container" [class.multi-tab]="tabs.length > 2">
            <a *ngFor="let tab of tabs"
               class="type-select"
               [ngClass]="{'selected': selectedTab === tab.id}"
               (click)="onSelectTab(tab.id)">
                {{ tab.labelKey | translate }}
            </a>
        </div>

        <div class="list" [class.has-selection-summary]="persistSelectionAcrossTabs">
            <txp-item-list class="item-list"
                           [header]="listTitle"
                           [enableSelection]="true"
                           [filterText]="filterText"
                           [enableMultiSelect]="true"
                           [hasCount]="!persistSelectionAcrossTabs"
                           [disableSelectionReset]="disableSelectionReset"
                           [selectedCatalogEntryIds]="currentTabSelectedIds"
                           [data]="currentList"
                           [entitiesSelectedText]="entitiesSelectedText"
                           (emitSelection)="persistSelectionAcrossTabs ? onSelectionChange($event) : (selectedItems = $event)"
                           listKey="name">
            </txp-item-list>
            @if (persistSelectionAcrossTabs) {
              <div class="selection-summary">
                <div>{{ tabSelectionSummary }}</div>
                <div>{{ totalSelectionSummary }}</div>
              </div>
            }
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <txp-button [style]="buttonStyle.SECONDARY"
                data-qa-label="CancelButton"
                (click)="handleCancel()">
        {{ 'form.button.cancel' | translate }}
    </txp-button>

    <txp-button [style]="buttonStyle.PRIMARY"
                data-qa-label="DoneButton"
                [disabled]="!hasSelection"
                (click)="handleDone()">
        {{ doneButtonLabelKey | translate }}
    </txp-button>
</mat-dialog-actions>
